import Home from "./home"

function StoreFront() {
    return (
        <div>
            <Home />
        </div>
    );
}

export default StoreFront;